<template>
  <div class="row info-container" v-if="parada != null">
    <div
      class="col-12 parada-info parada-alert"
      v-if="parada.estado == 'ERROR'"
    >
      <l-alert type="danger" icon="nc-icon nc-bell-55">
        <span>{{ parada.error || "Error en la parada" }}</span>
      </l-alert>
    </div>
    <div class="parada-detail-grid">
      <div class="parada-info">
        <h6>Parada:</h6>
        <ul>
          <li><b>Número:</b> {{ showValue(parada.numero) }}</li>
          <li>
            <b>Referencia courier:</b>
            {{ showValue(parada.referenciaCourier) }}
          </li>
          <li><b>Courier:</b> {{ showValue(parada.courier) }}</li>
        </ul>
      </div>
      <div class="parada-info" v-if="hasCliente">
        <h6>Cliente:</h6>
        <ul>
          <li><b>Cliente:</b> {{ clienteLabel }}</li>
          <li v-if="parada.cliente.agrupacion">
            <b>Agrupación:</b> {{ parada.cliente.agrupacion }}
          </li>
        </ul>
      </div>
      <div class="parada-info" v-if="hasRemitente">
        <h6>Remitente:</h6>
        <ul>
          <li><b>Remitente:</b> {{ showValue(parada.remitente.nombre) }}</li>
          <li>
            <b>Atención de:</b>
            {{ showValue(parada.remitente.atencionDe) }}
          </li>
          <li><b>Teléfono:</b> {{ telefonoRemitente }}</li>
          <li><b>Email:</b> {{ showValue(parada.remitente.email) }}</li>
        </ul>
      </div>
      <div class="parada-info" v-if="!hasCliente && !hasRemitente">
        <h6>Contacto:</h6>
        <ul>
          <li>Sin datos de cliente o remitente</li>
        </ul>
      </div>
      <div class="parada-info">
        <h6>Ruta:</h6>
        <ul>
          <li><b>Fecha:</b> {{ formatDate(parada.fecha) }}</li>
          <li><b>Dirección:</b> {{ showValue(parada.direccion) }}</li>
          <li><b>Horario:</b> {{ showValue(parada.horario) }}</li>
        </ul>
      </div>
      <div class="parada-info">
        <h6>Mercancía:</h6>
        <ul>
          <li v-if="parada.red"><b>Envíos:</b> {{ showValue(parada.red) }}</li>
          <li><b>Bultos:</b> {{ showValue(parada.bultos) }}</li>
          <li v-if="parada.kilos">
            <b>Kilos:</b> {{ showValue(parada.kilos) }}
          </li>
          <li v-if="parada.frio"><b>Frio:</b> Sí</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LAlert from "./Alert.vue";

export default {
  name: "detalle-parada",
  components: { LAlert },
  props: {
    parada: {
      required: true,
      default: () => null,
    },
  },
  computed: {
    hasCliente() {
      return this.parada && this.parada.cliente;
    },
    hasRemitente() {
      return this.parada && this.parada.remitente;
    },
    clienteLabel() {
      if (!this.hasCliente) return "-";
      const codigo = this.parada.cliente.codigo;
      const nombre = this.parada.cliente.nombre;
      if (codigo && nombre) return `${codigo} - ${nombre}`;
      return codigo || nombre || "-";
    },
    telefonoRemitente() {
      if (!this.hasRemitente || !this.parada.remitente.telefono) return "-";
      const prefijo = this.parada.remitente.telefono.prefijo;
      const numero = this.parada.remitente.telefono.numero;
      if (prefijo && numero) return `${prefijo} ${numero}`;
      return prefijo || numero || "-";
    },
  },
  methods: {
    showValue(value) {
      if (value === null || value === undefined || value === "") return "-";
      return value;
    },
    formatDate(fecha) {
      if (!fecha) return "-";
      return moment(fecha).format("DD/MMM/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.parada-alert {
  padding-left: 10px;
  padding-right: 25px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.parada-info {
  ul {
    list-style: none;
    padding-left: 0px;
    z-index: 100;
  }

  li {
    overflow-wrap: anywhere;
  }

  label {
    font-weight: bold;
    margin: 0;
    z-index: 200;
  }
}

.info-container {
  padding: 15px;
}

.parada-detail-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  width: 100%;
}

@media (max-width: 1199px) {
  .parada-detail-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .parada-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .parada-detail-grid {
    grid-template-columns: 1fr;
  }
}
</style>
